module.exports = __webpack_public_path__ + "equinor-logo.png";